var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('form-configuration-information'),_c('form-alarm-management'),_c('form-motor-data-table'),_c('form-vsd-alarm-limit-sensor'),_c('form-vsd-tag-alarm-limit'),_c('form-vsd-alarm-limit'),_c('form-recommendation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }